import { orchestrator } from "satcheljs";
import { selectFolder } from "owa-mail-folder-forest-actions";
import { setShowPstTasksMutator } from "../mutators/setShowPstTasksMutator";
import shouldShowPstTasks from "../selectors/shouldShowPstTasks";

/**
 * Reset PST Tasks view when selecting a folder
 */
orchestrator(selectFolder, () => {
    // Hide PST Tasks when any folder is selected
    if (shouldShowPstTasks()) {
        setShowPstTasksMutator(false);
    }
});
